import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '~/constants/react-query'
import { RawOrgBalancesResponse } from '~/hooks/useBalances'
import { useServerRequests } from '~/hooks/useRequests'

export const useHistoricalBalances = (params: {
  orgId: string | undefined
  date: string | undefined
  accountIds?: string[]
  chainIds?: number[]
  enabled?: boolean
}) => {
  const { serverGetRequest } = useServerRequests()

  return useQuery({
    queryKey: [
      QUERY_KEYS.HISTORICAL_BALANCES,
      params.orgId,
      params.date,
      params.accountIds,
      params.chainIds,
    ],
    queryFn: async () => {
      if (!params.orgId || !params.date) return null

      const queryParams: Record<string, string> = {
        orgId: params.orgId,
        date: params.date,
      }
      if (params.accountIds && params.accountIds.length > 0) {
        queryParams.accountIds = params.accountIds.join(',')
      }
      if (params.chainIds && params.chainIds.length > 0) {
        queryParams.chainIds = params.chainIds.join(',')
      }

      const response = await serverGetRequest<RawOrgBalancesResponse>({
        path: '/api/org/balances/historical',
        params: queryParams,
        errorMessage: 'Failed to fetch historical balances',
      })

      return response?.data ?? null
    },
    enabled: params.enabled ?? false,
    // 30 days in ms (30 * 24 * 60 * 60 * 1000)
    staleTime: (query) => (query.state.data ? 2_592_000_000 : 0),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 2,
  })
}
